import { Component, Inject, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { FormGroup, FormBuilder, FormControl, ReactiveFormsModule, FormsModule, Validators} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TeamService } from 'src/app/team-edit/services/team.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-non-active-work-dialog',
  imports: [
    CommonModule, 
    MatDialogModule, 
    ReactiveFormsModule, 
    FormsModule, 
    MatChipsModule, 
    MatFormFieldModule, 
    MatIconModule, 
    MatAutocompleteModule, 
    MatSelectModule, 
    MatInputModule, 
    MatButtonModule
  ],
  standalone: true,
  templateUrl: './non-active-work-dialog.component.html',
  styleUrl: './non-active-work-dialog.component.scss'
})
export class NonActiveWorkDialogComponent implements OnInit {
  protected svc_Team = inject(TeamService);
  fg_NonActiveWork: FormGroup = <FormGroup>{};
  
  nonWorkOptions: any[] = [
    { "move_status": false, "display": "ACTIVE", "variant_status": "active", "variant_msg":"" }, 
    { "move_status": false, "display": "INACTIVE - No work is assigned for this variant.", "variant_status": "inactive", "variant_msg": "No work is assigned for this variant." }, 
    { "move_status": true, "display" : "INACTIVE - Operator moves to another pitch.", "variant_status": "inactive", "variant_msg": "Operator moves to pitch " }
  ];

  movesToPitch: string = '';
  pitchList: any[] = [];
  variantStatus: string = 'active';
  variantMsg: string = '';

  variantOption: any = this.nonWorkOptions[0];

  constructor(
    public dialogRef: MatDialogRef<NonActiveWorkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inData: any,    
    private fb: FormBuilder,
    private dialog: MatDialog
  ){};

  ngOnInit(): void {
    console.log(this.inData)
    this.variantStatus = this.inData.variant_status? this.inData.variant_status: 'active';
    this.variantMsg = this.inData.variant_msg? this.inData.variant_msg: '';

    this.getPitchList()

    this.fg_NonActiveWork = this.fb.group({
      f_NonWorkOption: new FormControl(this.variantOption),
      f_MoveToPitch: new FormControl()
    })

    if (this.variantStatus == "inactive"){
      if (this.variantMsg == "No work is assigned for this variant."){
        this.variantOption = this.nonWorkOptions[1];
        this.fg_NonActiveWork.get('f_NonWorkOption')?.setValue(this.variantOption);
      } else {
        this.variantOption = this.nonWorkOptions[2];
        this.movesToPitch = this.variantMsg.split('pitch ')[1];
        this.variantMsg = this.variantMsg.split('pitch ')[0];
        this.variantOption.variant_msg = this.variantMsg;
        this.fg_NonActiveWork.get('f_NonWorkOption')?.setValue(this.variantOption);
        this.fg_NonActiveWork.get('f_MoveToPitch')?.setValue(this.movesToPitch);
      }
    }

    
    
    this.fg_NonActiveWork.controls['f_NonWorkOption'].valueChanges.subscribe((value)=>{
      console.log(value)
      this.variantOption = value;
      console.log(this.variantOption)
      if (this.variantOption.move_status){
        this.fg_NonActiveWork.get('f_MoveToPitch')?.enable({emitEvent: false});
        this.fg_NonActiveWork.get('f_MoveToPitch')?.setValidators(Validators.required);
      } else {
        this.fg_NonActiveWork.get('f_MoveToPitch')?.disable({emitEvent: false});
        this.fg_NonActiveWork.get('f_MoveToPitch')?.clearValidators();
      }
    });

    this.fg_NonActiveWork.controls['f_MoveToPitch'].valueChanges.subscribe((value)=>{
      this.movesToPitch = value;
      this.variantOption.variant_msg = this.variantOption.variant_msg + this.movesToPitch;
      console.log(this.variantOption)
    });
  }

  getPitchList(){
    console.log(this.inData)
    this.svc_Team.getPitches(this.inData.team_id, this.inData.version_id).subscribe(out=>{
      console.log(out.Body)
      out.Body.forEach(pitch=>{
        let pitch_info = pitch.pitch_id
        if (pitch.subassembly_id != '')
          pitch_info = pitch_info + ' (' + pitch.subassembly_id + ')'
        this.pitchList.push(pitch_info)
      });
    })
  }

  onNoClick():void{
    this.dialogRef.close()
  }

  onSubmit(){
    let returnData: any = { variant: { variant_status: this.variantOption.variant_status, variant_msg: this.variantOption.variant_msg }};
    if (this.fg_NonActiveWork.valid){
      this.dialogRef.close(returnData);
    } else {
      console.debug('Form is invalid')
    }
  }
}
